import _defineProperty from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _toConsumableArray from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _get from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _objectWithoutProperties from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React from 'react';
import classnames from 'classnames';
import immer from 'immer';
import { PureComponent } from '../component';
import { datepickerClass } from './styles';
import Icon from './Icon';
import utils from './utils';
import Picker from './Picker';
import Range from './Range';
import Text from './Text';
import { getUidStr } from '../utils/uid';
import { isArray } from '../utils/is';
import { getParent } from '../utils/dom/element';
import absoluteList from '../AnimationList/AbsoluteList';
import { docSize } from '../utils/dom/document';
import { getRTLPosition } from '../utils/strings';
import List from '../AnimationList';
import { getLocale } from '../locale';
import { isRTL } from '../config';
import InputTitle from '../InputTitle';
import { inputTitleClass } from '../InputTitle/styles';
import { getDirectionClass } from '../utils/classname';
var FadeList = List(['fade'], 'fast');
var OptionList = absoluteList(function (_ref) {
  var focus = _ref.focus,
      other = _objectWithoutProperties(_ref, ["focus"]);

  return (
    /*#__PURE__*/
    React.createElement(FadeList, Object.assign({
      show: focus
    }, other))
  );
});

var getCurrentPosition = function getCurrentPosition(position) {
  if (isRTL()) {
    return getRTLPosition(position);
  }

  return position;
};

var DefaultValue = {
  type: 'date',
  clearable: true,
  allowSingle: false,
  placeholder:
  /*#__PURE__*/
  React.createElement("span", null, "\xA0")
};

var Container =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Container, _PureComponent);

  var _super = _createSuper2(Container);

  function Container(props) {
    var _this;

    _classCallCheck(this, Container);

    _this = _super.call(this, props);
    _this.handleClick = void 0;
    _this.handleBlur = void 0;
    _this.disabledMap = void 0;
    _this.pickerId = void 0;
    _this.firstRender = void 0;
    _this.element = void 0;
    _this.picker = void 0;
    _this.pickerContainer = void 0;
    _this.textSpan = void 0;
    _this.lastFoucs = void 0;
    _this.state = {
      focus: false,
      current: _this.getCurrent(),
      position: props.position,
      picker0: false,
      picker1: false
    };
    _this.disabledMap = {};
    _this.pickerId = "picker_".concat(getUidStr());
    _this.bindElement = _this.bindElement.bind(_assertThisInitialized(_this));
    _this.bindPicker = _this.bindPicker.bind(_assertThisInitialized(_this));
    _this.bindWrappedPicker = _this.bindWrappedPicker.bind(_assertThisInitialized(_this));
    _this.bindTextSpan = _this.bindTextSpan.bind(_assertThisInitialized(_this));
    _this.handleClick = _this.handleToggle.bind(_assertThisInitialized(_this), true);
    _this.handleBlur = _this.handleToggle.bind(_assertThisInitialized(_this), false);
    _this.handleFocus = _this.handleFocus.bind(_assertThisInitialized(_this));
    _this.handleKeyDown = _this.handleKeyDown.bind(_assertThisInitialized(_this));
    _this.handleChange = _this.handleChange.bind(_assertThisInitialized(_this));
    _this.handleClear = _this.handleClear.bind(_assertThisInitialized(_this));
    _this.handleHover = _this.handleHover.bind(_assertThisInitialized(_this));
    _this.handleTextChange = _this.handleTextChange.bind(_assertThisInitialized(_this));
    _this.parseDate = _this.parseDate.bind(_assertThisInitialized(_this));
    _this.dateToCurrent = _this.dateToCurrent.bind(_assertThisInitialized(_this));
    _this.shouldFocus = _this.shouldFocus.bind(_assertThisInitialized(_this));
    _this.handleDisabled = _this.handleDisabled.bind(_assertThisInitialized(_this));
    _this.disabledRegister = _this.disabledRegister.bind(_assertThisInitialized(_this));
    _this.bindClickAway = _this.bindClickAway.bind(_assertThisInitialized(_this));
    _this.clearClickAway = _this.clearClickAway.bind(_assertThisInitialized(_this));
    _this.handleClickAway = _this.handleClickAway.bind(_assertThisInitialized(_this));
    _this.getDefaultTime = _this.getDefaultTime.bind(_assertThisInitialized(_this));
    _this.getQuick = _this.getQuick.bind(_assertThisInitialized(_this));
    _this.firstRender = !!props.open;
    return _this;
  }

  _createClass(Container, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      _get(_getPrototypeOf(Container.prototype), "componentDidMount", this).call(this);

      this.setOpenEvent();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.setOpenEvent();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      _get(_getPrototypeOf(Container.prototype), "componentWillUnmount", this).call(this);

      this.clearClickAway();
    }
  }, {
    key: "setOpenEvent",
    value: function setOpenEvent() {
      var focus = this.focus || this.props.inputFocus;
      if (this.lastFoucs !== focus) if (focus) {
        this.bindClickAway();
      } else if (this.lastFoucs !== undefined) {
        this.clearClickAway();
      }
      this.lastFoucs = focus;
    }
  }, {
    key: "getOptions",
    value: function getOptions() {
      var timeZone = this.props.timeZone;
      return {
        timeZone: timeZone,
        weekStartsOn: getLocale('startOfWeek')
      };
    }
  }, {
    key: "getCurrent",
    value: function getCurrent() {
      var _this2 = this;

      var current;
      var _this$props = this.props,
          defaultRangeMonth = _this$props.defaultRangeMonth,
          defaultPickerValue = _this$props.defaultPickerValue,
          value = _this$props.value;

      if (this.props.range) {
        var defaultPickerRange = defaultRangeMonth || defaultPickerValue || [];
        current = (this.props.value || []).map(function (v, i) {
          v = _this2.parseDate(v);
          if (utils.isInvalid(v)) v = utils.newDate(defaultPickerRange[i], _this2.getOptions());
          return v;
        });
        if (current.length === 0) current = [utils.newDate(defaultPickerRange[0], this.getOptions()), utils.newDate(defaultPickerRange[1], this.getOptions())];
      } else {
        current = this.parseDate(value || defaultPickerValue);
      }

      return current;
    }
  }, {
    key: "getFormat",
    value: function getFormat() {
      var _this$props2 = this.props,
          format = _this$props2.format,
          type = _this$props2.type;

      if (format) {
        if (type === 'week' && format.indexOf('I') > -1) return format.replace(/y/g, 'Y');
        return format;
      }

      switch (type) {
        case 'date':
          return 'YYYY-MM-DD';

        case 'month':
          return 'YYYY-MM';

        case 'time':
          return 'HH:mm:ss';

        case 'year':
          return 'YYYY';

        case 'week':
          return 'GGGG WW';

        case 'quarter':
          return 'YYYY-[Q]Q';

        default:
          return 'YYYY-MM-DD HH:mm:ss';
      }
    }
  }, {
    key: "getQuick",
    value: function getQuick(format) {
      var _this3 = this;

      var quickSelect = this.props.quickSelect;
      if (!Array.isArray(quickSelect)) return undefined;
      return quickSelect.map(function (q) {
        var invalid = false;
        if (!q.value) return {
          name: q.name,
          invalid: true
        };
        var date = (Array.isArray(q.value) ? q.value : [q.value]).map(function (v) {
          return utils.toDateWithFormat(v, format, undefined, _this3.getOptions());
        });
        if (utils.isInvalid(date[0])) invalid = true;
        if (date[1] && utils.isInvalid(date[1])) invalid = true;
        if (invalid) return {
          name: q.name,
          invalid: true
        };
        return {
          name: q.name,
          value: date
        };
      });
    }
  }, {
    key: "getDefaultTime",
    value: function getDefaultTime() {
      var defaultTime = this.props.defaultTime;
      if (typeof defaultTime === 'string') return [defaultTime];
      if (isArray(defaultTime)) return defaultTime;
      return [];
    }
  }, {
    key: "bindElement",
    value: function bindElement(el) {
      this.element = el;
    }
  }, {
    key: "bindPicker",
    value: function bindPicker(picker) {
      this.picker = picker;
    }
  }, {
    key: "bindWrappedPicker",
    value: function bindWrappedPicker(el) {
      this.pickerContainer = el;
    }
  }, {
    key: "bindTextSpan",
    value: function bindTextSpan(el) {
      this.textSpan = el;
    }
  }, {
    key: "parseDate",
    value: function parseDate(value) {
      return utils.toDateWithFormat(value, this.getFormat(), undefined, this.getOptions());
    }
  }, {
    key: "bindClickAway",
    value: function bindClickAway() {
      document.addEventListener('mousedown', this.handleClickAway);
    }
  }, {
    key: "clearClickAway",
    value: function clearClickAway() {
      document.removeEventListener('mousedown', this.handleClickAway);
    }
  }, {
    key: "shouldFocus",
    value: function shouldFocus(el) {
      if (el.getAttribute('data-id') === this.pickerId) return true;
      if (getParent(el, ".".concat(datepickerClass('result')))) return true;
      return false;
    }
  }, {
    key: "handleClickAway",
    value: function handleClickAway(e) {
      var onPicker = e.target === this.element || this.element.contains(e.target);
      var onAbsolutePicker = getParent(e.target, ".".concat(datepickerClass('location')));

      if (!onPicker && !onAbsolutePicker) {
        if (this.props.inputable && this.textSpan) this.textSpan.blur();
        this.handleToggle(false);
        if (this.props.onBlur) this.props.onBlur(e);
      }
    }
  }, {
    key: "handleFocus",
    value: function handleFocus(e) {
      if (!this.shouldFocus(e.target)) return;
      if (this.props.onFocus) this.props.onFocus(e);
      this.bindClickAway();
    }
  }, {
    key: "handleKeyDown",
    value: function handleKeyDown(e) {
      if (e.keyCode === 13) {
        e.preventDefault();
        this.handleToggle(!this.focus);
      } // fot close the list


      if (e.keyCode === 9) {
        this.props.onBlur(e); // e.preventDefault()

        if (this.focus) {
          this.handleToggle(false);
        }
      }
    }
  }, {
    key: "handleToggle",
    value: function handleToggle(focus, e) {
      var _this4 = this;

      var _this$props3 = this.props,
          quickSelect = _this$props3.quickSelect,
          onCollapse = _this$props3.onCollapse;
      var hasQuickColumn = Array.isArray(quickSelect) && quickSelect.length > 0;
      if (this.props.disabled === true) return;
      if (focus === this.focus) return;
      if (e && focus && getParent(e.target, this.pickerContainer)) return; // click close icon

      if (focus && e && e.target.classList.contains(datepickerClass('close'))) return;
      if (onCollapse) onCollapse(focus);
      this.setState(immer(function (state) {
        state.focus = focus;

        if (focus === true) {
          var rect = _this4.element.getBoundingClientRect();

          var windowHeight = docSize.height;
          var windowWidth = docSize.width;
          var pickerWidth = (_this4.props.range ? 540 : 270) + (hasQuickColumn ? 120 : 0);

          if (!_this4.props.position) {
            if (rect.bottom + 300 > windowHeight) {
              if (rect.left + pickerWidth > windowWidth) state.position = 'right-top';else state.position = 'left-top';
            } else if (rect.left + pickerWidth > windowWidth) state.position = 'right-bottom';else state.position = 'left-bottom';
          }

          state.current = _this4.getCurrent();
        }
      }));

      if (focus && this.picker && 'resetRange' in this.picker && this.picker.resetRange) {
        this.picker.resetRange((this.props.value || []).map(this.parseDate));
      }

      if (focus === true) {
        // this.firstRender = true
        // this.props.onFocus()
        this.bindClickAway();
      } else {
        this.props.onValueBlur();
      }
    }
  }, {
    key: "triggerValueBlur",
    value: function triggerValueBlur(cb) {
      var inputable = this.props.inputable;
      if (cb && typeof cb === 'function') cb(); // OnChange is not triggered when handling copy and paste

      if (inputable && this.focus === false) {
        this.props.onValueBlur();
      }
    }
  }, {
    key: "disabledRegister",
    value: function disabledRegister(disabled, mode, index) {
      if (index === undefined) {
        this.disabledMap[mode] = disabled;
        return;
      }

      if (!this.disabledMap[mode]) this.disabledMap[mode] = [];
      this.disabledMap[mode][index] = disabled;
    }
  }, {
    key: "handleDisabled",
    value: function handleDisabled(date, index) {
      var mode = this.props.type;
      var disabledMap = this.disabledMap;
      var isRange = index !== undefined;

      switch (mode) {
        case 'time':
          return isRange ? disabledMap.time[index](date, undefined, undefined, true) : disabledMap.time(date, undefined, undefined, true);

        case 'date':
          return isRange ? disabledMap.day[index](date) : disabledMap.day(date);

        case 'week':
          return isRange ? disabledMap.day[index](date) : disabledMap.day(date);

        case 'month':
          return isRange ? disabledMap.month[index](date) : disabledMap.month(date);

        case 'year':
          return isRange ? disabledMap.year[index](date) : disabledMap.year(date);

        case 'quarter':
          return isRange ? disabledMap.quarter[index](date) : disabledMap.quarter(date);

        case 'datetime':
          return isRange ? disabledMap.time[index](date, undefined, undefined, true) || disabledMap.day[index](date) : disabledMap.time(date, undefined, undefined, true) || disabledMap.day(date);

        default:
          return false;
      }
    }
  }, {
    key: "handleTextChange",
    value: function handleTextChange(date, index, e) {
      var _this5 = this;

      var _this$props4 = this.props,
          disabledTime = _this$props4.disabledTime,
          disabled = _this$props4.disabled,
          max = _this$props4.max,
          min = _this$props4.min,
          range = _this$props4.range;
      var format = this.getFormat();
      var val = date ? utils.format(date, format, this.getOptions()) : '';
      var isDisabled;

      if (disabled || disabledTime || max || min || range) {
        isDisabled = this.handleDisabled(date, index);
        if (isDisabled) return;
      }

      if (!this.props.range && this.props.onChange) {
        var close = !(e && e.target && this.element.contains(e.target));
        this.props.onChange(val, close ? this.triggerValueBlur.bind(this, this.handleBlur) : undefined);
        return;
      }

      var value = _toConsumableArray(immer(this.props.value === undefined && range ? [] : this.props.value, function (draft) {
        draft[index] = val;
      }));

      if (utils.compareAsc(value[0], value[1]) > 0) value.push(value.shift());

      if (this.props.onChange) {
        this.props.onChange(value, this.triggerValueBlur.bind(this, function () {
          _this5.setState({
            current: _this5.getCurrent()
          });
        }));
      }
    }
  }, {
    key: "dateToCurrent",
    value: function dateToCurrent(date) {
      var range = this.props.range;
      if (!range || !Array.isArray(date)) return date;
      var current = this.state.current;
      return [date[0] || current[0], date[1] || current[1]];
    }
  }, {
    key: "handleChange",
    value: function handleChange(date, change, blur, _isEnd, isQuickSelect, areaType) {
      var _this6 = this;

      var onPickerChange = this.props.onPickerChange; // is range only select one

      var rangeOne = this.props.range && Array.isArray(date) && !(date[0] && date[1]);
      var format = this.getFormat();
      var value;
      if (this.props.range && Array.isArray(date)) value = date.map(function (v) {
        return v ? utils.format(v, format, _this6.getOptions()) : v;
      });else value = utils.format(date, format, this.getOptions());
      var callback;
      if (!this.props.range) callback = blur ? this.handleBlur : undefined;else {
        callback = blur && !rangeOne ? this.handleBlur : undefined;
      }
      var newCurrent = this.dateToCurrent(date);
      if (onPickerChange) onPickerChange(value, isQuickSelect, areaType);

      if (change) {
        this.setState({
          current: newCurrent
        });
        this.props.onChange(value, callback, isQuickSelect);
      } else {
        this.setState({
          current: newCurrent
        }, callback);
      }
    }
  }, {
    key: "handleClear",
    value: function handleClear(e) {
      var _this7 = this;

      var clearWithUndefined = this.props.clearWithUndefined;
      e.stopPropagation();
      var empty = clearWithUndefined ? undefined : '';
      var value = this.props.range ? [empty, empty] : empty;
      this.props.onChange(value, function () {
        _this7.props.onValueBlur();

        _this7.handleToggle(false);

        _this7.element.focus();
      });
    }
  }, {
    key: "handleHover",
    value: function handleHover(index, isEnter) {
      this.setState(_defineProperty({}, "picker".concat(index), isEnter));
    }
  }, {
    key: "renderText",
    value: function renderText(value, placeholder, key) {
      var _this$props5 = this.props,
          inputable = _this$props5.inputable,
          formatResult = _this$props5.formatResult,
          disabled = _this$props5.disabled;
      var date = this.parseDate(value);
      var className = classnames(datepickerClass('txt', key !== undefined && this.state["picker".concat(key)] && 'text-focus'));
      var resultFormat = formatResult || this.getFormat();
      return (
        /*#__PURE__*/
        React.createElement(Text, {
          key: key || 'single',
          onTextSpanRef: this.bindTextSpan,
          focusElement: this.textSpan,
          className: className,
          focus: this.focus,
          format: resultFormat,
          index: key,
          inputable: inputable,
          placeholder: placeholder,
          onChange: this.handleTextChange,
          value: utils.isInvalid(date) ? undefined : utils.format(date, resultFormat, this.getOptions()),
          disabled: disabled === true
        })
      );
    }
  }, {
    key: "renderResult",
    value: function renderResult() {
      var _this8 = this;

      var _this$props6 = this.props,
          disabled = _this$props6.disabled,
          range = _this$props6.range,
          placeholder = _this$props6.placeholder,
          type = _this$props6.type,
          innerTitle = _this$props6.innerTitle,
          inputable = _this$props6.inputable;
      var value = this.props.value;
      if (!value && range) value = []; // const isEmpty = !value || value.length === 0

      var clearable = this.props.clearable;
      if (disabled === true) clearable = false;
      var isEmpty = (range ? value : [value]).reduce(function (result, str) {
        var date = _this8.parseDate(str);

        return result && utils.isInvalid(date);
      }, true);
      return (
        /*#__PURE__*/
        React.createElement("div", {
          className: datepickerClass('result')
        },
        /*#__PURE__*/
        React.createElement(InputTitle, {
          className: datepickerClass('title-box'),
          contentClass: inputTitleClass('hidable'),
          innerTitle: innerTitle,
          open: !isEmpty || inputable && this.focus
        }, range && Array.isArray(value) ? [this.renderText(value[0], placeholder[0], 0),
        /*#__PURE__*/
        React.createElement("span", {
          key: "-",
          className: datepickerClass('separate')
        }, "~"), this.renderText(value[1], placeholder[1], 1)] : this.renderText(value, placeholder)),
        /*#__PURE__*/
        React.createElement(Icon, {
          className: isEmpty || !clearable ? '' : 'indecator',
          name: type === 'time' ? 'Clock' : 'Calendar'
        }), !isEmpty && clearable &&
        /*#__PURE__*/
        React.createElement(Icon, {
          name: "CloseCircle",
          className: "close",
          tag: "a",
          onClick: this.handleClear
        }))
      );
    }
  }, {
    key: "renderWrappedPicker",
    value: function renderWrappedPicker() {
      var position = this.state.position;
      var _this$props7 = this.props,
          absolute = _this$props7.absolute,
          zIndex = _this$props7.zIndex,
          quickSelect = _this$props7.quickSelect;
      var props = {
        absolute: absolute,
        focus: this.focus,
        className: datepickerClass('picker', 'location', "absolute-".concat(getCurrentPosition(position)), quickSelect && getDirectionClass('quick')),
        zIndex: zIndex,
        getRef: this.bindWrappedPicker // computed absolute position needed

      };

      if (absolute) {
        props.rootClass = datepickerClass('absolute', isRTL() && 'rtl');
        props.parentElement = this.element;
        props.position = position;
      } else {
        props.position = getCurrentPosition(position);
      }

      return (
        /*#__PURE__*/
        React.createElement(OptionList, props, this.renderPicker())
      );
    }
  }, {
    key: "renderPicker",
    value: function renderPicker() {
      var _this9 = this;

      if (!this.firstRender && !this.focus) return undefined;
      this.firstRender = true;
      var _this$props8 = this.props,
          range = _this$props8.range,
          type = _this$props8.type,
          value = _this$props8.value,
          min = _this$props8.min,
          max = _this$props8.max,
          disabled = _this$props8.disabled,
          allowSingle = _this$props8.allowSingle,
          hourStep = _this$props8.hourStep,
          minuteStep = _this$props8.minuteStep,
          secondStep = _this$props8.secondStep,
          disabledTime = _this$props8.disabledTime,
          timeZone = _this$props8.timeZone;
      var format = this.getFormat();
      var quicks = this.getQuick(format);
      var Component = range ? Range : Picker;
      return (
        /*#__PURE__*/
        React.createElement(Component, {
          ref: this.bindPicker,
          defaultTime: this.getDefaultTime(),
          current: this.state.current,
          format: format,
          disabled: typeof disabled === 'function' ? disabled : undefined,
          onChange: this.handleChange,
          type: type,
          range: range,
          quicks: quicks,
          value: range ? (value || []).map(function (v) {
            return _this9.parseDate(v);
          }) : this.parseDate(value),
          showTimePicker: !!value,
          allowSingle: allowSingle,
          handleHover: this.handleHover,
          min: utils.toDateWithFormat(min, format, undefined, this.getOptions()),
          max: utils.toDateWithFormat(max, format, undefined, this.getOptions()),
          hourStep: hourStep,
          minuteStep: minuteStep,
          secondStep: secondStep,
          disabledTime: disabledTime,
          disabledRegister: this.disabledRegister,
          timeZone: timeZone
        }, this.props.children)
      );
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props9 = this.props,
          range = _this$props9.range,
          size = _this$props9.size,
          disabled = _this$props9.disabled,
          align = _this$props9.align,
          innerTitle = _this$props9.innerTitle;
      var rtl = isRTL();
      var className = datepickerClass('inner', range && 'range', size && "size-".concat(size), this.focus && 'focus', disabled === true && 'disabled', align && "align-".concat(align), getCurrentPosition(this.state.position), rtl && 'rtl', innerTitle && 'inner-title');
      return (
        /*#__PURE__*/
        React.createElement("div", {
          // eslint-disable-next-line
          tabIndex: disabled === true ? -1 : 0,
          className: className,
          onFocus: this.handleFocus,
          "data-id": this.pickerId,
          ref: this.bindElement,
          onClick: this.handleClick,
          onKeyDown: this.handleKeyDown
        }, this.renderResult(), this.renderWrappedPicker())
      );
    }
  }, {
    key: "focus",
    get: function get() {
      if ('open' in this.props) {
        return !!this.props.open;
      }

      return this.state.focus;
    }
  }]);

  return Container;
}(PureComponent);

Container.defaultProps = DefaultValue;
export default Container;